    <p-toast position="bottom-right"></p-toast>
    <p-confirmDialog></p-confirmDialog>
    <app-recap-sidebar>
      <app-report-tasks-table body [transPartKey]="transPartKey" [origins]="origins"></app-report-tasks-table>
    </app-recap-sidebar>

